import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  ANY_SPORT_ONBOARDING_TUTORIAL_RECRUIT,
  ANY_SPORT_ONBOARDING_TUTORIAL_WIN,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

import { MarketGuidanceLayout } from '#src/components/onboarding/MarketGuidanceLayout/index.tsx';
import { PlayLineupAnimation } from '#src/components/onboarding/PlayLineupAnimation/index.tsx';
import { ConversionCredit } from '#src/pages/onboarding_/tutorial/ConversionCredit/index.tsx';

import mlbLineup from './assets/mlbLineup.webp';

const Root = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  flex: 1;
`;

const StyledFooter = styled(Vertical)`
  position: sticky;
  bottom: var(--double-unit);
  align-self: center;
`;

const TutorialPlayPage = () => {
  const { generateSportContextPath, sport } = useSportContext();

  return (
    <MarketGuidanceLayout
      progress={3}
      center
      backUrl={generateSportContextPath(ANY_SPORT_ONBOARDING_TUTORIAL_RECRUIT)}
    >
      <Root>
        <Vertical gap={1.5} center>
          <FormattedMessage
            defaultMessage="<em>Play</em><label>with lineups of {count} players</label>"
            values={{
              count: sport === Sport.BASEBALL ? 7 : 5,
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        {sport === Sport.BASEBALL ? (
          <img
            width={560}
            src={mlbLineup}
            alt="MLB Lineup"
            style={{ maxWidth: '100%' }}
          />
        ) : (
          <PlayLineupAnimation />
        )}
        <StyledFooter gap={0}>
          <ConversionCredit />
          <OnboardingButton
            size="large"
            color="secondary"
            to={generateSportContextPath(ANY_SPORT_ONBOARDING_TUTORIAL_WIN)}
            prefetch="render"
          >
            <FormattedMessage {...glossary.continue} />
          </OnboardingButton>
        </StyledFooter>
      </Root>
    </MarketGuidanceLayout>
  );
};
export default TutorialPlayPage;
